<template>
    <form-section>
        <v-input :rules="[validate]" ref="input">
            <div style="width: 100%">
                Authorised Signature:
                <form-section style="position: relative; height: 300px">
                    <canvas
                        ref="canvas"
                        style="
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            border-radius: 4px;
                            box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
                        "
                    />
                </form-section>

                <div class="mt-2 d-flex" style="width: 100%">
                    <v-btn class="mr-2" @click="clear">Clear</v-btn>
                    <v-btn class="ml-auto" @click="undo">Undo</v-btn>
                </div>
                <div v-html="hint" class="text-caption mt-2" />
            </div>
        </v-input>
    </form-section>
</template>

<script>
import SignaturePad from "signature_pad";
import FormSection from "./FormSection";
import Vapor from "../../Modules/Vapor";

export default {
    name: "SignatureField",

    components: { FormSection },

    props: {
        hint: {
            default: "",
            type: String,
        },
    },

    data() {
        return {
            pad: null,
        };
    },

    mounted() {
        this.resizeCanvas();

        this.pad = new SignaturePad(this.$refs.canvas);

        window.addEventListener("resize", this.resizeCanvas);

        this.pad.addEventListener("beginStroke", this.resetValidation);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.resizeCanvas);
        this.pad.removeEventListener("beginStroke", this.resetValidation);
    },

    methods: {
        clear() {
            this.pad?.clear();
        },

        undo() {
            const data = this.pad.toData();

            if (data) {
                data.pop();
                this.pad.fromData(data);
            }
        },

        resizeCanvas() {
            const ratio = Math.max(window.devicePixelRatio || 1, 1);

            this.$refs.canvas.width = this.$refs.canvas.offsetWidth * ratio;
            this.$refs.canvas.height = this.$refs.canvas.offsetHeight * ratio;
            this.$refs.canvas.getContext("2d").scale(ratio, ratio);

            this.clear();
        },

        validate() {
            return !this.pad?.isEmpty() || "Please complete the Signature";
        },

        async resetValidation() {
            await this.$nextTick();

            this.$refs.input.validate();
        },

        async getBlob() {
            if (this.pad.isEmpty()) {
                return {};
            }

            const file = new File(
                [
                    await new Promise((resolve) => {
                        this.$refs.canvas.toBlob(resolve);
                    }),
                ],
                "signature.png",
                { type: "image/png" }
            );

            const upload = await Vapor.store(file, {
                visibility: "public-read",
                signedStorageUrl: this.route("signed-storage-url.store"),
            });

            return {
                type: upload.extension,
                tmp: upload.key,
            };
        },
    },
};
</script>

<style scoped></style>
